export default {
    data() {
        return {
            statesWithName: [
                { name: "Alabama", alpha_2: "AL" },
                { name: "Alaska", alpha_2: "AK" },
                { name: "Arizona", alpha_2: "AZ" },
                { name: "Arkansas", alpha_2: "AR" },
                { name: "California", alpha_2: "CA" },
                { name: "Colorado", alpha_2: "CO" },
                { name: "Connecticut", alpha_2: "CT" },
                { name: "Delaware", alpha_2: "DE" },
                { name: "District of Columbia", alpha_2: "DC" },
                { name: "Florida", alpha_2: "FL" },
                { name: "Georgia", alpha_2: "GA" },
                { name: "Hawaii", alpha_2: "HI" },
                { name: "Idaho", alpha_2: "ID" },
                { name: "Illinois", alpha_2: "IL" },
                { name: "Indiana", alpha_2: "IN" },
                { name: "Iowa", alpha_2: "IA" },
                { name: "Kansa", alpha_2: "KS" },
                { name: "Kentucky", alpha_2: "KY" },
                { name: "Lousiana", alpha_2: "LA" },
                { name: "Maine", alpha_2: "ME" },
                { name: "Maryland", alpha_2: "MD" },
                { name: "Massachusetts", alpha_2: "MA" },
                { name: "Michigan", alpha_2: "MI" },
                { name: "Minnesota", alpha_2: "MN" },
                { name: "Mississippi", alpha_2: "MS" },
                { name: "Missouri", alpha_2: "MO" },
                { name: "Montana", alpha_2: "MT" },
                { name: "Nebraska", alpha_2: "NE" },
                { name: "Nevada", alpha_2: "NV" },
                { name: "New Hampshire", alpha_2: "NH" },
                { name: "New Jersey", alpha_2: "NJ" },
                { name: "New Mexico", alpha_2: "NM" },
                { name: "New York", alpha_2: "NY" },
                { name: "North Carolina", alpha_2: "NC" },
                { name: "North Dakota", alpha_2: "ND" },
                { name: "Ohio", alpha_2: "OH" },
                { name: "Oklahoma", alpha_2: "OK" },
                { name: "Oregon", alpha_2: "OR" },
                { name: "Pennsylvania", alpha_2: "PA" },
                { name: "Rhode Island", alpha_2: "RI" },
                { name: "South Carolina", alpha_2: "SC" },
                { name: "South Dakota", alpha_2: "SD" },
                { name: "Tennessee", alpha_2: "TN" },
                { name: "Texas", alpha_2: "TX" },
                { name: "Utah", alpha_2: "UT" },
                { name: "Vermont", alpha_2: "VT" },
                { name: "Virginia", alpha_2: "VA" },
                { name: "Washington", alpha_2: "WA" },
                { name: "West Virginia", alpha_2: "WV" },
                { name: "Wisconsin", alpha_2: "WI" },
                { name: "Wyoming", alpha_2: "WY" },
                { name: "US Virgin Islands", alpha_2: "VI" },
                { name: "Puerto rico", alpha_2: "PR" }
            ],
        }
    }
}